<template>
  <v-dialog v-model="dialog" persistent max-width="1100" overlay-color="grey darken-3">
    <v-card class="rounded-xl overflow-hidden shadow-24">
      <!-- HEADER PRINCIPAL -->
      <v-toolbar flat color="primary" dark height="auto" class="py-2">
        <v-icon left size="28">mdi-folder-information</v-icon>
        <v-toolbar-title class="text-h5 font-weight-bold text-wrap-title">
          Gestión de <span class="white--text text--lighten-2">{{ region.name }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        
        <div class="hidden-xs-only mr-4">
          <v-btn color="success" class="mr-2 rounded-lg" depressed @click="$emit('ver-en-arbol', region)">
            <v-icon left>mdi-format-list-bulleted</v-icon> Árbol
          </v-btn>
          <v-btn v-if="verPlanos" color="success" class="rounded-lg" depressed @click="$emit('ver-en-plano', region)">
            <v-icon left>mdi-map-marker-path</v-icon> Plano
          </v-btn>
        </div>

        <v-btn icon @click="close" class="grey lighten-4 primary--text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- NAVEGACIÓN DE TABS (ARTÍCULOS SIEMPRE VISIBLE) -->
      <v-tabs v-model="activeTab" background-color="grey lighten-4" color="primary" grow slider-size="4">
        <v-tab class="font-weight-bold text-none">
          <v-icon left>mdi-paperclip</v-icon> Adjuntos ({{ adjuntos.length }})
        </v-tab>
        <v-tab class="font-weight-bold text-none">
          <v-icon left>mdi-package-variant-closed</v-icon> 
          Artículos
          <v-chip v-if="!puedeVerArticulos" x-small color="amber darken-2" dark class="ml-2 font-weight-black" label>
            PRO
          </v-chip>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- TAB ADJUNTOS (Igual que antes) -->
        <v-tab-item class="pa-4 grey lighten-5">
          <v-card flat outlined class="rounded-lg">
            <v-data-table :headers="headersAdjuntos" :items="adjuntos" :items-per-page="5" class="rounded-lg border-light">
              <template #top>
                <v-row class="pa-4" align="center">
                  <v-col cols="12" sm="8">
                    <v-text-field v-model="searchAdjuntos" prepend-inner-icon="mdi-magnify" label="Filtrar archivos..." outlined dense hide-details class="rounded-pill white"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4" class="text-right" v-if="puedeAdjuntar">
                    <v-btn color="primary" block class="rounded-lg" @click="$emit('add-adjunto', region)">
                      <v-icon left>mdi-cloud-upload</v-icon> Subir Archivo
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
               <!-- NUEVO: Nombre con salto de línea -->
              <template #item.name="{ item }">
                <div class="text-wrap-cell font-weight-bold">
                  {{ item.name }}
                </div>
              </template>

              <!-- NUEVO: Descripción con salto de línea -->
              <template #item.descripcion="{ item }">
                <div class="text-wrap-cell grey--text text--darken-2">
                  {{ item.descripcion || '—' }}
                </div>
              </template>
                <!-- NUEVO: Fecha en formato Madrid -->
              <template #item.created_at="{ item }">
                <span class="text-no-wrap">
                  {{ formatFecha(item.created_at) }}
                </span>
              </template>
                          <template #item.usuario="{ item }">
                <v-chip small color="blue lighten-5" class="primary--text font-weight-medium">
                  <v-icon left x-small>mdi-account</v-icon>{{ item.usuario?.username || '—' }}
                </v-chip>
              </template>
              <template #item.actions="{ item }">
                <!-- <v-btn icon color="primary" @click="visualizarAdjunto(item)"><v-icon>mdi-eye-outline</v-icon></v-btn> -->
                <v-btn icon color="grey darken-1" @click="descargarAdjunto(item.id)"><v-icon>mdi-download</v-icon></v-btn>
                <v-btn v-if="puedeEliminar" icon color="error lighten-1" @click="eliminarAdjunto(item.id)"><v-icon>mdi-delete-outline</v-icon></v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>

        <!-- TAB ARTÍCULOS (LÓGICA DE MARKETING) -->
        <v-tab-item class="pa-4 grey lighten-5">
          <!-- CASO 1: TIENE PERMISO -->
          <v-card v-if="puedeVerArticulos" flat outlined class="rounded-lg">
            <v-data-table :headers="headersArticulos" :items="articulos" :items-per-page="5" :search="searchArticulos" class="rounded-lg">
              <template #top>
                <v-text-field v-model="searchArticulos" label="Buscar en inventario..." class="pa-4" prepend-inner-icon="mdi-magnify" outlined dense hide-details />
              </template>
            </v-data-table>
          </v-card>

          <!-- CASO 2: ESTRATEGIA DE MARKETING (LOCK) -->
          <v-card v-else flat class="pa-10 text-center rounded-lg border-gold bg-white">
            <v-row justify="center" align="center">
              <v-col cols="12" md="8">
                <div class="premium-icon-container mb-4">
                  <v-icon size="100" color="amber darken-3">mdi-shield-star</v-icon>
                </div>
                <h2 class="text-h4 font-weight-black grey--text text--darken-3 mb-2">
                  Gestión de Inventario PRO
                </h2>
                <p class="text-subtitle-1 grey--text text--darken-1 mb-6">
                  Vincula piezas de repuesto, herramientas y consumibles directamente a tus activos. 
                  Optimiza tus tiempos de mantenimiento sabiendo exactamente qué necesitas antes de empezar.
                </p>
                
                <!-- <v-row class="mb-6 text-left" dense>
                  <v-col cols="12" sm="6" v-for="(feature, i) in ['Stock en tiempo real', 'Alertas de repuestos', 'Historial de consumos', 'Códigos QR por pieza']" :key="i">
                    <div class="d-flex align-center">
                      <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                      <span class="font-weight-medium grey--text text--darken-2">{{ feature }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-btn color="amber darken-3" dark x-large class="rounded-xl px-10 font-weight-black elevation-4">
                  <v-icon left>mdi-rocket-launch</v-icon>
                  ¡LO QUIERO! - DESBLOQUEAR AHORA
                </v-btn>
                
                <div class="mt-4">
                  <a href="#" class="caption primary--text font-weight-bold text-decoration-none">Ver todas las ventajas de la versión Premium</a>
                </div> -->
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-divider></v-divider>

      <v-card-actions class="pa-4 grey lighten-4">
        <span class="caption grey--text font-italic ml-2 italic-id">UID: {{ region.id }}</span>
        <v-spacer></v-spacer>
        <v-btn text color="grey darken-2" class="font-weight-bold px-6" @click="$emit('close')">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
// Importación y configuración de PDF.js
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.js";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;


export default {
  props: {
    dialog: { type: Boolean, required: true },
    adjuntos: { type: Array, default: () => [] },
    articulos: { type: Array, default: () => [] },
    region: { type: Object, default: null },

    verPlanos: {type: Boolean, default: true},
    puedeEditar: {type: Boolean, default: true},

    puedeAdjuntar: {type: Boolean, default: true},
    puedeEliminar: {type: Boolean, default: true},
  },

  data() {
    return {
      searchAdjuntos: '',
      searchArticulos: '',
      headersAdjuntos: [
        { text: 'Usuario', value: 'usuario', sortable: false },
        { text: 'Nombre', value: 'name', sortable: true },
        { text: 'Tipo', value: 'tipo', sortable: true },
        { text: 'Fecha', value: 'created_at', sortable: true },
        { text: 'Descripción', value: 'descripcion', sortable: false },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      headersArticulos: [
        { text: 'Referencia', value: 'referencia', sortable: true },
        { test: 'Nombre', value: 'nombre', sortable: true }
      ],
      viewerDialog: false,
      viewerUrl: '',
      viewerType: '',
      viewerTitle: '',
      viewerId: null, 

      activeTab: 0,
      searchAdjuntos: "",
      searchArticulos: "",
    };
  },

  computed: {
    ...mapState(['user', 'usuarios', 'permisos']),
    ...mapState("armarios", ["stateSelectedNode"]),

    puedeVerArticulos(){
      return this.permisos.includes('piezas');
    }
  },

  methods: {

    formatFecha(fechaISO) {
      if (!fechaISO) return '—';
      
      try {
        const fecha = new Date(fechaISO);
        return new Intl.DateTimeFormat('es-ES', {
          timeZone: 'Europe/Madrid',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }).format(fecha);
      } catch (e) {
        return fechaISO;
      }
    },
    descargarAdjunto(idAdjunto) {
      const url = `/api/nodejs/armarios/adjuntos/${idAdjunto}/download`;
      window.open(url, '_blank', 'noopener,noreferrer');
    },

    async visualizarAdjunto(item) {
      this.viewerTitle = item.name;
      this.viewerId = item.id;
      const rawUrl = `/api/nodejs/armarios/adjuntos/${item.id}/download`;

      const filePath = item.ruta || item.name;
      const extension = filePath.split(".").pop().toLowerCase();

      if (extension === "pdf") {
        this.viewerType = "pdf";
        try {
          const response = await axios.get(rawUrl, { responseType: "arraybuffer" });
          const pdfData = response.data;
          this.viewerDialog = true;
          this.$nextTick(() => this.renderPdf(pdfData));
        } catch (error) {
          console.error("Error al obtener el PDF:", error);
          this.viewerDialog = false;
          this.$emit("error", "Error al cargar el PDF.");
        }
      } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
        this.viewerType = "image";
        const response = await axios.get(rawUrl, { responseType: "blob" });
        const blobUrl = URL.createObjectURL(response.data);
        if (this.viewerUrl && this.viewerUrl.startsWith("blob:")) {
          URL.revokeObjectURL(this.viewerUrl);
        }
        this.viewerUrl = blobUrl;
        this.viewerDialog = true;
      } else {
        this.viewerType = extension || "NO ENCONTRADA";
        this.viewerUrl = "";
        this.viewerDialog = true;
      }
    },

    async renderPdf(pdfData) {
      const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
      const container = this.$refs.pdfContainer ?? document.getElementById("pdf-viewer");
      if (!container) return;
      container.innerHTML = "";

      const containerWidth = container.clientWidth;

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const originalViewport = page.getViewport({ scale: 1 });
        const scale = containerWidth / originalViewport.width;
        const viewport = page.getViewport({ scale });

        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        container.appendChild(canvas);
        await page.render({ canvasContext: ctx, viewport }).promise;
      }
    },

    async eliminarAdjunto(idAdjunto) {
      if (!confirm("¿Estás seguro de que quieres eliminar este adjunto?")) return;
      try {
        await axios.delete(`/api/nodejs/armarios/adjuntos/${idAdjunto}`);
        this.$emit('refresh-adjuntos'); 
      } catch (error) {
        console.error("Error al eliminar el adjunto:", error);
        this.$emit('error', "No se pudo eliminar el adjunto");
      }
    },

    formatFecha(fechaISO) {
      if (!fechaISO) return '';
      const fecha = new Date(fechaISO);
      return `${fecha.getDate().toString().padStart(2,'0')}/${
        (fecha.getMonth()+1).toString().padStart(2,'0')}/${
        fecha.getFullYear()} ${fecha.getHours().toString().padStart(2,'0')}:${
        fecha.getMinutes().toString().padStart(2,'0')}`;
    },

    close() {
      if (this.viewerUrl && this.viewerUrl.startsWith('blob:')) {
        URL.revokeObjectURL(this.viewerUrl);
      }
      this.viewerDialog = false; 
      this.$emit("close")
    }
  },
};
</script>

<style scoped>
.border-gold {
  border: 2px dashed #ffb300 !important;
  background: linear-gradient(to bottom right, #ffffff, #fffdf2);
}

.premium-icon-container {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
}

.shadow-24 {
  box-shadow: 0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12), 0 11px 15px -7px rgba(0,0,0,0.2) !important;
}

.italic-id {
  opacity: 0.6;
  letter-spacing: 1px;
}

/* Mejora el visor de archivos para que parezca profesional */
.pdf-container { width: 100%; height: 100%; background: #333; }

.text-wrap-cell {
  white-space: normal !important; /* Permite saltos de línea */
  word-break: break-word;        /* Rompe palabras si son demasiado largas */
  line-height: 1.4;              /* Mejora la legibilidad */
  padding: 8px 0;                /* Espaciado para que no se peguen las líneas */
  min-width: 120px;              /* Ancho mínimo para evitar columnas colapsadas */
}

/* Opcional: ajustar el ancho de la columna de fecha para que no baile */
.text-no-wrap {
  white-space: nowrap !important;
}
.text-wrap-title {
  white-space: normal !important;
  word-wrap: break-word;
  overflow: visible !important;
  line-height: 1.2; /* Ajusta para que no se peguen las líneas */
  padding: 8px 0;   /* Espacio extra arriba y abajo */
  flex: 1;          /* Permite que tome el espacio necesario */
}
</style>